import React from "react"
import { Container, Row, Col } from "reactstrap"
import {Link} from "react-router-dom"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col sm={12}>
              © {new Date().getFullYear()} My Urban Farms. All Rights Reserved <span className="d-none d-sm-inline-block"> - Designed by <Link
  to="https://capdigisoft.com/"
  target="_blank"
  rel="noopener noreferrer"
>
  CAP Digisoft.
</Link>
</span>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
